import { render, staticRenderFns } from "./hello.vue?vue&type=template&id=830e074e&"
import script from "./hello.vue?vue&type=script&lang=js&"
export * from "./hello.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports